import { Message } from '@material-ui/icons';
import MessageList from './MessageList';
import { MessageShow } from './MessageShow';

export default {
    list: MessageList,
    show: MessageShow,
    icon: Message,
};
